import request from '@/utils/request'

// 查询员工
export function getUsers(params) {
  return request({
    url: '/api/users/',
    method: 'get',
    params
  })
}

// 编辑员工
export function editUsers(data) {
  return request({
    url: '/api/users/' + data.id + '/',
    method: 'put',
    data
  })
}

// 新增员工
export function createUsers(data) {
  return request({
    url: '/api/users/',
    method: 'post',
    data
  })
}

// 删除员工
export function deleteUsers(id) {
  return request({
    url: '/api/users/' + id,
    method: 'delete',
  })
}

// 获取 OSS 上传凭证
export function getOSSPolicy() {
  return request({
    url: '/api/uploads/oss_policy/',
    method: 'get'
  })
}

// 上传（单张 - 已废弃，请使用 @/utils/oss-upload.js 中的 uploadSingleImage）
// 直传 OSS 后调用此接口创建数据库记录
export function uploadFile(data) {
  return request({
    url: '/api/uploads/',
    method: 'post',
    data
  })
}

// 批量创建图片记录
export function uploadFilesBatch(data) {
  return request({
    url: '/api/uploads/',
    method: 'post',
    data
  })
}

// 3D列表查询
export function getThreeds(params) {
  return request({
    url: '/api/threeds/',
    method: 'get',
    params
  })
}

// 一键更新所有用户密码
export function updateSitePassword(data) {
  return request({
    url: '/api/users/update_site_password/',
    method: 'post',
    data
  })
}

// 更新单个用户密码
export function updateUserPassword(user_id, data) {
  return request({
    url: `/api/users/${user_id}/update_user_site_password/`,
    method: 'put',
    data
  })
}

// 批量获取评分统计
export function getBatchRatingStats(params) {
  return request({
    url: '/api/ratings/batch_stats/',
    method: 'get',
    params
  })
}

// 获取工人评分记录
export function getWorkerRatings(workerId, params) {
  return request({
    url: `/api/ratings/worker/${workerId}/ratings/`,
    method: 'get',
    params
  })
}

// 删除评分记录
export function deleteRate(id) {
  return request({
    url: '/api/ratings/' + id,
    method: 'delete',
  })
}

// 修改登录密码
export function changePassword(data) {
  return request({
    url: '/api/users/change_password/',
    method: 'post',
    data
  })
}